import React from "react";
import "../../CSS/ai.css";
import { Link } from "react-router-dom";

function AIVideoCreator() {
    return (
        <div className="ai-page">
           
            <section className="ai-hero">
                <div className="container">
                    <div className="ai-hero-content">
                        <h1>
                            AI Video<br />
                            <span>
                                Creator & Editor
                            </span>
                        </h1>
                        <p>
                            Create professional videos from your ideas using AI-powered
                            video generation and editing tools.
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= AI VIDEO SERVICES ================= */}
            <section className="ai-service-info-section">
                <div className="container">

                    <div className="ai-sections-heading text-center">
                        <h2>
                            AI Video Creation & Editing
                        </h2>
                    </div>

                    <div className="row g-4 mt-4">

                        {/* Video Creation */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    🎬
                                </div>

                                <h3>
                                    AI Video Creation
                                </h3>

                                <p>
                                    Create engaging video content for your business, products,
                                    services, marketing campaigns, and social media platforms.
                                </p>

                            </div>
                        </div>


                        {/* Video Editing */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    ✂️
                                </div>

                                <h3>
                                    AI Video Editing
                                </h3>

                                <p>
                                    Improve existing videos with AI-assisted editing, captions,
                                    transitions, formatting, and other creative enhancements.
                                </p>

                            </div>
                        </div>


                        {/* Marketing Videos */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    📢
                                </div>

                                <h3>
                                    Marketing Videos
                                </h3>

                                <p>
                                    Create promotional videos, product presentations,
                                    advertisements, and social media content for your business.
                                </p>

                            </div>
                        </div>


                        {/* Social Media */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    📱
                                </div>

                                <h3>
                                    Social Media Content
                                </h3>

                                <p>
                                    Develop short-form video content suitable for social media,
                                    digital campaigns, and online brand promotion.
                                </p>

                            </div>
                        </div>


                        {/* Business Videos */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    💼
                                </div>

                                <h3>
                                    Business Videos
                                </h3>

                                <p>
                                    Professional videos for company introductions, services,
                                    presentations, training, and internal communication.
                                </p>

                            </div>
                        </div>


                        {/* Custom */}
                        <div className="col-lg-4 col-md-6">
                            <div className="ai-info-card">

                                <div className="ai-info-icon">
                                    ⚡
                                </div>

                                <h3>
                                    Custom Video Solutions
                                </h3>

                                <p>
                                    Customized video solutions based on your business goals,
                                    audience, branding, and content requirements.
                                </p>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* CTA */}
            <section className="cta-section">

                <div className="container">
                    <div className="cta-box">

                        <div className="cta-content">
                            <span className="ai-cta-label">
                                START YOUR PROJECT
                            </span>
                            <h2>
                                Need Professional Video Content?
                            </h2>
                            <p>
                                Tell us about your project and we can help you create the
                                right video solution for your business.
                            </p>
                        </div>

                        <Link
                            to="/contactus"
                            className="cta-button" style={{ textDecoration: 'none' }}
                        >
                            Get In Touch
                        </Link>

                    </div>
                </div>


            </section >

        </div >
    );
}

export default AIVideoCreator;